var settings = {
  protocol: "wss",
  host: "topquiz.at",
  port: "1338",
  web_root: "",
  mailContact: "support@topquiz.at",
  version: "Beta v3.7.4",
  copyRight: "&copy; 2021, Infinite Elements",
  verbose: false
};

module.exports = settings;
